<template>
	<div class="sign-in">
		<a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle" class="row-main">
			<!-- Register Form Column -->
			<a-col class="col-form">
				<h4 class="mb-15">Register</h4>
				<p class="text-muted">Enter your credentials to register</p>
				<!-- Sign Form -->
				<div v-if="errorMessage" class="error-message">
					{{ errorMessage }}
				</div>
				<a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit"
					:hideRequiredMark="true">
					<a-form-item class="mb-10" label="Username" :colon="false">
						<a-input id="username" v-decorator="[
							'username',
							{ rules: [{ required: true, message: 'Please input your username!' }] },
						]" placeholder="Username" />
					</a-form-item>
					<a-form-item class="mb-10" label="First Name" :colon="false">
						<a-input id="firstname" v-decorator="[
							'firstname',
							{ rules: [{ required: true, message: 'Please input your first name!' }] },
						]" placeholder="First Name" />
					</a-form-item>
					<a-form-item class="mb-10" label="Last Name" :colon="false">
						<a-input id="lastname" v-decorator="[
							'lastname',
							{ rules: [{ required: true, message: 'Please input your last name!' }] },
						]" placeholder="Last Name" />
					</a-form-item>
					<a-form-item class="mb-10" label="Email" :colon="false">
						<a-input id="email" v-decorator="[
							'email',
							{ rules: [{ type: 'email', message: 'The input is not valid E-mail!' }, { required: true, message: 'Please input your email!' }] },
						]" placeholder="Email" />
					</a-form-item>
					<a-form-item class="mb-10" label="Password" :colon="false">
						<a-input id="password" v-decorator="[
							'password',
							{ rules: [{ required: true, message: 'Please input your password!' }] },
						]" type="password" placeholder="Password" :type="showPassword ? 'text' : 'password'">
							<template slot="suffix">
								<a-icon @click="toggleShowPassword" :type="showPassword ? 'eye-invisible' : 'eye'" />
							</template>
						</a-input>
					</a-form-item>
					<a-form-item class="mb-10" label="Confirm Password" :colon="false">
						<a-input id="confirm-password" v-decorator="[
							'confirmPassword',
							{ rules: [{ required: true, message: 'Please confirm your password!' }, { validator: this.validateConfirmPassword }] },
						]" placeholder="Confirm Password" :type="showConfirmPassword ? 'text' : 'password'">
							<template slot="suffix">
								<a-icon @click="toggleShowConfirmPassword"
									:type="showConfirmPassword ? 'eye-invisible' : 'eye'" />
							</template>
						</a-input>
					</a-form-item>
					<a-form-item>
						<a-button type="primary" block html-type="submit" class="login-form-button" :disabled="isLoading"
							:loading="isLoading">
							Register
						</a-button>
					</a-form-item>
				</a-form>
			</a-col>
		</a-row>
		<a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle" class="row-main">
			<span>Already have an account?</span>
				<a-button @click="toLoginPage()">Login</a-button>
		</a-row>
	</div>
</template>

<script>
import router from "@/router";

export default {
	data() {
		return {
			form: this.$form.createForm(this, { name: "Login_illustration" }),
			isLoading: false,
			errorMessage: null,
			showPassword: false,
			showConfirmPassword: false,
			data: []
		};
	},
	methods: {
		handleSubmit(e) {
			e.preventDefault();
			this.form.validateFields((err, values) => {
				if (!err) {
					this.isLoading = true;
					this.$store
						.dispatch("user/register", {
							username: values.username,
							firstname: values.firstname,
							lastname: values.lastname,
							email: values.email,
							password: values.password,
						})
						.then((res) => {
							this.isLoading = false;
							console.log('register', res)
						})
						.catch((error) => {
							this.isLoading = false;
							this.errorMessage = "Register failed";
							console.error("Register Error:", error);
						});
				}
			});
		},
		validateConfirmPassword(rule, value, callback) {
			if (value && value !== this.form.getFieldValue('password')) {
				callback('Passwords do not match!');
			} else {
				callback();
			}
		},
		toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
		toggleShowConfirmPassword() {
			this.showConfirmPassword = !this.showConfirmPassword;
		},
		toLoginPage() {
			router.go(-1);
		}
	},
};
</script>

<style>
.error-message {
	color: red;
	margin-bottom: 10px;
}

/* Adjust the form width */
.col-form,
.login-form {
	max-width: 1000px;
	/* Adjust this value as needed */
}
</style>
